import React, { SyntheticEvent, useState } from "react";
import { AnyColor } from "react-colorful/dist/types";

import ColorSwatch from "./parts/ColorSwatch";
import PopoverColorPicker from "./parts/PopoverColorPicker";
import { PopoverOrigin } from "@mui/material";

interface ColorSelectorProps {
  anchorOrigin?: PopoverOrigin;
  color?: AnyColor;
  defaultColor?: AnyColor;
  transformOrigin?: PopoverOrigin;
  showInput: boolean;
  onChange: (color: AnyColor) => void;
}

export default function ColorSelector(props: ColorSelectorProps): React.JSX.Element {
  const [showInput, /* setShowInput */] = useState(props.showInput || (props.showInput ?? true));
  const [isOpen, setIsOpen] = useState(false);
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleOpenPicker = (event: SyntheticEvent) => {
    if (!isOpen) {
      setAnchor(event.currentTarget as HTMLElement);
      setIsOpen(true);
    }
  }

  const handleColorChange = (color: AnyColor) => {
    props.onChange(color);
  }

  const handlePickerClose = () => {
    setIsOpen(false);
    setAnchor(null);
  }

  return (
    <>
      <ColorSwatch 
        color={props.color}
        defaultColor={props.defaultColor}
        onClick={handleOpenPicker} />
      <PopoverColorPicker
        anchor={anchor as HTMLElement}
        anchorOrigin={props.anchorOrigin}
        defaultColor={props.defaultColor}
        transformOrigin={props.transformOrigin}
        color={props.color}
        isOpen={isOpen}
        showInput={showInput}
        onChange={handleColorChange}
        onClose={handlePickerClose} />
    </>
  )
}
